export default {
  setOverlay(state, { component, data }) {
    state.overlay = { component, data }
  },
  setError(state, { resource, code }) {
    state.error.resource = resource
    state.error.code = code
  },
}
